import {
  PuxCheckbox,
  PuxItem,
  PuxLabel,
  useBreakpoint,
} from "@phonero/pux-react"
import { Input } from "./Input"
import { InfoBox } from "../Other/InfoBox"

export interface ICheckboxItem {
  id: string
  checked: boolean
  label: string
  labelFontWeight?: string | number
  slotDetailContent?: any
  slotEndContent?: any
  infoMessage?: string | null
  onToggle: any
  icon: any
}

export const CheckBoxItem = ({
  id,
  label,
  labelFontWeight,
  checked,
  slotDetailContent,
  slotEndContent,
  onToggle,
  infoMessage,
  icon,
  ref: _ref,
  ...rest
}: ICheckboxItem & ConstructorParameters<typeof PuxItem>[0]) => {
  const s = useBreakpoint("sm", { useMin: true })

  return (
    <PuxItem
      detail={false}
      forceAllowMultipleInputs
      ignoreClicks
      detailVisible={checked}
      {...rest}
      style={{ "--detail-margin-bottom": 0, ...rest.style }}
    >
      <PuxCheckbox
        id={id}
        slot={"start"}
        checked={checked}
        onPuxChange={onToggle}
      ></PuxCheckbox>
      {icon}
      <div style={{ paddingInline: 10, width: "100%" }}>
        <Input
          htmlFor={id}
          label={
            <PuxLabel style={{ fontWeight: labelFontWeight }}>{label}</PuxLabel>
          }
        />
      </div>

      {(!!infoMessage || !!slotEndContent) && (
        <div
          slot={"end"}
          style={{
            paddingLeft: 10,
            gap: 20,
            display: "flex",
            alignItems: "center",
          }}
        >
          {slotEndContent}
          {!!infoMessage && <InfoBox message={infoMessage ?? ""} />}
        </div>
      )}
      {!!slotDetailContent && (
        <div
          slot={"detail"}
          style={{
            paddingInline: s ? 80 : 20,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {slotDetailContent}
        </div>
      )}
    </PuxItem>
  )
}
